import quantityId from '../enums/quantityId.js';
import Quantity from '../entities/quantity.js';
import Unit from '../entities/unit.js';

const angle = new Quantity(
    quantityId.ANGLE,
    'Angle'
);

angle.registerUnit(
    new Unit(
        'deg', 1, 'degree', [
            "°", '˚', 'º', 'o', 'deg', '&#176', '&deg;'
        ]
    )
);

angle.registerUnit(
    new Unit(
        'rad', 0.017453292519943, 'radian', [
            "rad", 'c'
        ]
    )
);

export default angle;